/** Explain an unsuccessful save without discarding the builder's edits. */
export function describeQuoteSaveError(error: unknown): string {
  const message = error instanceof Error ? error.message : "";
  const requestId = error && typeof error === "object" && "requestId" in error
    ? String(error.requestId || "") : "";
  let description = "Your changes have not been saved. Please try again.";
  if (/^(401|403):/.test(message)) {
    description = "Your session may have expired or you may not have access to this quotation. Sign in again before retrying.";
  } else if (/Failed to fetch|Load failed|NetworkError/i.test(message)) {
    description = "The connection was interrupted. Your changes are still on this page. Check your connection and try saving again.";
  } else {
    try {
      const start = message.indexOf("{"), end = message.lastIndexOf("}");
      const body = JSON.parse(message.slice(start, end + 1));
      const reason = body.message ?? body.error;
      if (typeof reason === "string") description = reason;
      const detail = Array.isArray(body.details) ? body.details[0]?.message : undefined;
      if (typeof detail === "string") description += ` ${detail}`;
    } catch {
      // Never put an HTML error page or an unstructured server response in a toast.
    }
  }
  return requestId ? `${description} Reference: ${requestId}` : description;
}
